/**  @deprecated legacy mews-ui theme variable */
export interface BasicColorSet extends ColorSet {
    background: string;
    backgroundDark: string;

    foreground: string;

    text: string;
    textSecondary: string;
    textContrast: string;

    hover: string;

    placeholder: string;
    border: string;
    label: string;

    imageBackground: string;
    imagePlaceholder: string;
}

/**  @deprecated legacy mews-ui theme variable */
export interface ColorSet {
    base: string;

    background: string;
    backgroundLight: string;
    backgroundSecondary: string;
    backgroundTertiary: string;

    hover: string;
    hoverLight: string;

    focus: string;
    focusLight: string;

    active: string;
    activeLight: string;

    text: string;
    textContrast: string;
    textSecondaryContrast: string;

    border: string;

    dataVisualizationBackground: string;
}
